import { render, staticRenderFns } from "./NoordHolland.vue?vue&type=template&id=4d41617c&"
var script = {}
import style0 from "./NoordHolland.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoordHolland.vue"
export default component.exports